import { appstr } from "../utils/appstr";
import { kAccountADPBasic, kAccountADPPremium } from "../constants";
import { GetUnknownErrorMessage } from "../utils/GetUnknownErrorMessage";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { ThrowHTMLStatusAlert } from "../utils/ThrowHTMLStatusAlert";
import { Globals } from "./Globals";
import { gKeyRetrievalFailureKey } from "../whitelabel/brand";

export class QDataRefreshRFC extends QRFC {
  constructor() {
    super();
    this.fPostRefresh = false; //Refresh the underlying FE doc after deep refresh.
  }

  InitQDataRefreshQuery(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qmongorfc";
  }

  SetParams(orgName, userName, mode, data, chartID) {
    this.AddParameter("chartID", chartID);
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  SetParamsExplicit(orgName, userName, mode, data, chartID) {
    this.AddParameter("chartID", chartID);
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  SetParamsNoChart(orgName, userName, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    if (Globals._wsMgr && Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
    }
    Globals._timerMgr.ClearTimer();
    Globals._wsMgr.fWaiting = null;
    var p = JSON.parse(response);

    if (p["success"]) {
      if (p["code"] == "dump") {
        callBackObj.DownloadMetadataDump(p["info"]);
      }

      if (this["clearctdirty"]) callBackObj.GetChartTemplatesMgr().ClearDirty();

      if (this.fPostRefresh) {
        Globals._wsMgr.RefreshDocFromBase(callBackObj);
      }
      if (this.fShowUpdateStatus != null) {
        ThrowHTMLStatusAlert("success", this.fShowUpdateStatus);
      }
      if (p["updatedUser"]) {
        Globals._wsMgr.UpdateUserInfo(p["updatedUser"]);
      }
      if (p["newMetadata"]) {
        // we could pass the full metadata in here, but im hesitant to do so - we dont want to overwrite the charts list that comes back since its the full chart metadata and not the slim version
        if (p["newMetadata"]["appendtables"]) {
          Globals._wsMgr.UpdateMetadata({ appendtables: p["newMetadata"]["appendtables"] });
        }
      }
      if (p["charts"]) {
        // This is used after checkpoint reset
        Globals._wsMgr.fOrgInfo.SetMasterChartList(p["charts"]);
      }
    } else if (!p["success"]) {
      var alert = new QAlert();
      var isBasic = Globals._accountInfo.GetOC5Edition() === kAccountADPBasic;
      var alertMessage = p["message"];
      var alertHeaderStr = appstr("Alert");
      if (p["newMetadata"] != null) {
        callBackObj.fChartInfo = p["newMetadata"];
        callBackObj.fClonedChartInfo = JSON.parse(JSON.stringify(p["newMetadata"]));
      }

      switch (p["code"]) {
        case "0001":
          var isPremium = Globals._accountInfo.GetOC5Edition() == kAccountADPPremium;
          if (isPremium) {
            // var consentPanel = new QPremiumConsentPanel();
            // consentPanel.InitFramelessPanel(Globals._wsMgr);
            Globals._wsMgr.PrepRenderWS();
            Globals._wsMgr.RenderWS();
            return;
          } else alertMessage = appstr(gKeyRetrievalFailureKey);

          break;
        case "0002":
          alertHeaderStr = appstr("fileloaderr2");
          alertMessage = `${appstr("fileloaderr3")}: "${p.message}"`;
          break;
        case "0003":
          alertMessage = appstr("CSVRefreshFailure");
          break;
        case "7029":
          alertMessage = appstr("7029");
          break;
        case "0013":
          alertMessage = appstr("loadheadersfailure");
          break;
        case "0024":
          alertMessage = "Users are not permitted to manually refresh this chart.";
          break;
        case "2016":
          alertMessage = appstr("2016");
          break;
        case "0500":
        case "0503":
          alertMessage = appstr("0503");
          break;
        case "0429":
          alertMessage = appstr("0429");
          break;
        case "0400":
          alertMessage = p["message"] ? appstr("0400") + " | " + p["message"] : appstr("0400");
          break;
        case "6004":
          alertMessage = appstr("6004");
          break;
        case "6000":
          alertMessage = appstr("6000");
          break;
        // default api timeout error
        case "0408":
          alertMessage = appstr("API Timeout Message");
          alertHeaderStr = appstr("API Timeout");
          break;
        case "9999":
          //Catch all for unhandled exceptions
          if (alertMessage == null || alertMessage === "Failure ")
            alertMessage = isBasic ? appstr("unknownerrnoemail") : GetUnknownErrorMessage();
          break;
      }
      alert.InitAlert(alertHeaderStr, alertMessage, null, Globals._wsMgr);
    }

    if (this.fReactCallback && callBackObj) callBackObj.HandleResponse(p["success"], p);

    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
